import {
    Directive,
    Input,
} from '@angular/core';
import {
    MatAnchor,
    MatButton,
} from '@angular/material/button';
import { MatMenuItem } from '@angular/material/menu';

import { AuthorizeBaseDirective } from './authorize-base.directive';

export interface IFolderPermissionExpression {
    folderId: number;
    permissionExpression: string;
}

@Directive({
    selector: '[uiAuthorizeDisable][folderId]',
    providers: [MatButton, MatAnchor, MatMenuItem],
})
export class FolderAuthorizeDirective extends AuthorizeBaseDirective {
    @Input('uiAuthorizeDisable')
    public set permissionDisable(permission: string) {
        this._permissionExpression = permission;
        this._trySetPermission();
    }

    @Input('folderId')
    public set folderId(id: number) {
        this._folderId = id;
        this._trySetPermission();
    }

    private _folderId!: number;
    private _permissionExpression!: string;

    protected _isGranted(permission: string) {
        return this._appState.user.folderPermissions.isGranted(this._folderId, permission);
    }

    private _trySetPermission() {
        if (this._folderId == null || this._permissionExpression == null) {
            return;
        }

        this._permissionDisable = this._permissionExpression;
    }
}
